import { parse } from 'date-fns';
import { enUS } from 'date-fns/locale';

export const UTC = 'UTC';
export const DEFAULT_MIN_YEAR = 1900;
export const DEFAULT_DATE_LOCALE = enUS;
export const DEFAULT_MIN_DATE = parse(`01/01/${DEFAULT_MIN_YEAR}`, 'P', new Date());
